// extracted by mini-css-extract-plugin
module.exports = {"formAdd":"Home_formAdd__FEjKb","buttonAdd":"Home_buttonAdd__3o7eO"};